<template>
	<div v-loading="loading" style="width: 100%;height: 100%"
			element-loading-text="登录校验中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
	></div>
</template>

<script>
	export default {
		data: function() {
			return {
				targetUrl:''
			};
		},
		created() {
			let targetUrl = this.$route.query.targetUrl;
			if(targetUrl){
				this.targetUrl = targetUrl;
			}
			let key = localStorage.getItem("sso-key");
			if (key){
					this.HTTP.get("/sso/login/check?key="+key).then(res=>{
						if (res.data.success){
							if (this.targetUrl){
								window.location.href =this.targetUrl+"?key="+key;
							}else{
								this.$router.push("/main");
							}
						}else{
							localStorage.removeItem("sso-key");
							this.$router.push("/loginform");
						}
					});
			}else {
				this.$router.push("/loginform");
			}
		},
		methods: {

		},
	};
</script>
<style>
</style>
<style scoped>
</style>
